import React from "react";
import ParticleEffect from "./ParticleEffect";
import { Link } from "react-router-dom";
import logoImg from "../static/img/Footer logo.png";

const FooterSection = () => {
  return (
    <footer className="relative bg-[#111] text-white py-24 px-8 overflow-hidden">
      <ParticleEffect speed={0.18} density={40} color="#ffffff25" />

      <div className="max-w-[1400px] mx-auto relative z-10">
        
        {/* MAIN GRID - Logo + All Columns */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 mb-20">
          
          {/* LOGO + DESCRIPTION COLUMN */}
          <div className="lg:col-span-2">
          <img src={logoImg} alt="Bloom Social" className=" w-[155px] h-[65px] mb-[25px] item-left object-left" />

            <p className="text-gray-400 text-[16px] leading-relaxed max-w-[400px]">
              From recording to results — we make your content work for you.
            </p>
          </div>
          
          {/* COMPANY COLUMN */}
          <div>
            <h4 className="text-[17px] font-medium mb-6 text-gray-400">Company</h4>
            <ul className="space-y-4 text-[16px] text-white">
              <li className="cursor-pointer hover:text-gray-300"
                onClick={() => { window.location.href = "/#services"; }}>
                Services
              </li>
              <li className="cursor-pointer hover:text-gray-300"
                onClick={() => { window.location.href = "/#process"; }}>
                Process
              </li>
              <li className="cursor-pointer hover:text-gray-300"
                onClick={() => { window.location.href = "/#faq"; }}>
                FAQ
              </li>
              <li className="cursor-pointer hover:text-gray-300"
                onClick={() => { window.location.href = "/#reviews"; }}>
                Reviews
              </li>
            </ul>
          </div>

          {/* JOIN US COLUMN */}
          <div>
            <h4 className="text-[17px] font-medium mb-6 text-gray-400">Join Us</h4>
            <ul className="space-y-4 text-[16px] text-white">
              <li className="cursor-pointer hover:text-gray-300"
                onClick={() => { window.location.href = "/career"; }}>
                Career
              </li>
            </ul>
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-gray-500 text-[15px]">
            Copyright 2026 to Bloom Social
          </p>
        </div>

      </div>
    </footer>
  );
};

export default FooterSection;